import { render, staticRenderFns } from "./expenseCategoriesComponent.vue?vue&type=template&id=7bd451aa&"
import script from "./expenseCategoriesComponent.vue?vue&type=script&lang=js&"
export * from "./expenseCategoriesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports